import NavBar from '../home/components/NavBar';
import FaqSection from '../home/components/FaqSection';
import Footer from '../home/components/Footer';

export default function FaqPage() {
  return (
    <main className="min-h-screen bg-[#EFEBE5]">
      <NavBar />
      <div className="pt-20">
        <FaqSection />
      </div>
      <Footer />
    </main>
  );
}
